<template>
    <div id="larativo-member-login-modal" ref="modalLogin" class="modal" tabindex="-1">
        <div class="modal-dialog">
            <div class="modal-content rounded-4 shadow">
                <div class="modal-header p-5 pb-4 border-bottom-0">
                    <h5 class="modal-title">Anmelden</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body p-5 pt-0">
                    <login @logged-in="loggedId" @logged-out="loggedOut" />
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, inject } from "vue"
import Login from "../../Components/Auth/Login"
import { Inertia } from "@inertiajs/inertia";
const auth = inject('auth');

const modalLogin = ref(null)
function modal() {
    return bootstrap.Modal.getOrCreateInstance(modalLogin.value);
}
function loggedId(response) {
    // console.log("Login", response);
    modal().hide();
    Inertia.reload({
        // onSuccess: page => {
        //     if (!page.props.auth.user.has_verified_email) {
        //         console.log("NOT VERIFIED");
        //     }
        // },
    });
}
function loggedOut(response) {
    // console.log("Logout", response);
    modal().hide();
    Inertia.reload();
}
</script>
